import { Component, Input, ElementRef, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dropdown-item',
    templateUrl: './dropdown-item.component.html',
    styleUrls: ['./dropdown-item.component.css']
})

export class DropdownItemComponent {
    @Input() items: Array<any>;
    @Input() selectedItem: any;
    @Output() onItemSelect: EventEmitter<any> = new EventEmitter();

    constructor(private elementRef: ElementRef) {
    }

    ngOnChanges(changes: any) {
    }

    click(event) {
        this.onItemSelect.emit(event);
    }

    onItemSelectEmit(event) {
        this.onItemSelect.emit(event);
    }

    getIcon(item) {
        if (item.icon) {
            return item.icon;
        } else {
            return '&nbsp;';
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/ng-dropdown/dropdown-item.component.ts